import * as Sentry from '@sentry/react';

import { PlatformBridge } from './bridge';

export interface LangPlugin {
  setLanguage(options: { languageCode: string }): Promise<{ success: boolean }>;
  getLanguage(): Promise<{ languageCode: string }>;
}

function getCapacitorLang(): LangPlugin | null {
  const plugins = PlatformBridge.capacitorPlugins;
  if (!plugins) return null;
  return (plugins.Lang as LangPlugin) ?? null;
}

export const LangBridge = {
  getLang(): LangPlugin | null {
    const capacitorLang = getCapacitorLang();
    if (capacitorLang) return capacitorLang;
    return null;
  },

  /**
   * Change l'application locale sur Android
   * @param languageCode Code de langue (ex: 'fr', 'en', 'es', etc.)
   */
  async setLanguage(languageCode: string): Promise<boolean> {
    const lang = this.getLang();
    if (!lang) {
      return false;
    }

    const currentLanguage = await this.getLanguage();
    if (currentLanguage === languageCode) {
      return true;
    }

    try {
      const result = await lang.setLanguage({ languageCode });
      return result.success;
    } catch (error) {
      console.error('LangBridge.setLanguage error:', error);
      Sentry.captureException(error);
      return false;
    }
  },

  /**
   * Récupère la langue actuelle de l'application
   * @returns Le code de langue actuel
   */
  async getLanguage(): Promise<string | null> {
    const lang = this.getLang();
    if (!lang) {
      return null;
    }

    try {
      const result = await lang.getLanguage();
      return result.languageCode;
    } catch (error) {
      console.error('LangBridge.getLanguage error:', error);
      Sentry.captureException(error);
      return null;
    }
  },
};
